// extracted by mini-css-extract-plugin
module.exports = {"fileInfo":"fileInfo___1l3Ei","card":"card___297rO","img":"img___3Sv_1","info":"info___3aP4E","infoSize":"infoSize___1tyU4","Progress":"Progress___zWJGU"};